/**
 * Represents various levels of logging.
 */
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 0] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["FATAL"] = 5] = "FATAL";
})(exports.LogLevel || (exports.LogLevel = {}));
var LogLevel = exports.LogLevel;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvcmUvTG9nTGV2ZWwudHMiXSwibmFtZXMiOlsiTG9nTGV2ZWwiXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsV0FBWSxRQUFRO0lBQ2xCQSx5Q0FBS0EsQ0FBQUE7SUFDTEEseUNBQUtBLENBQUFBO0lBQ0xBLHVDQUFJQSxDQUFBQTtJQUNKQSx1Q0FBSUEsQ0FBQUE7SUFDSkEseUNBQUtBLENBQUFBO0lBQ0xBLHlDQUFLQSxDQUFBQTtBQUNQQSxDQUFDQSxFQVBXLGdCQUFRLEtBQVIsZ0JBQVEsUUFPbkI7QUFQRCxJQUFZLFFBQVEsR0FBUixnQkFPWCxDQUFBIiwiZmlsZSI6ImNvcmUvTG9nTGV2ZWwuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFJlcHJlc2VudHMgdmFyaW91cyBsZXZlbHMgb2YgbG9nZ2luZy5cbiAqL1xuZXhwb3J0IGVudW0gTG9nTGV2ZWwge1xuICBUUkFDRSxcbiAgREVCVUcsXG4gIElORk8sXG4gIFdBUk4sXG4gIEVSUk9SLFxuICBGQVRBTFxufVxuIl0sInNvdXJjZVJvb3QiOiIvc291cmNlLyJ9



//////////////////
// WEBPACK FOOTER
// ./~/localstorage-logger/build/core/LogLevel.js
// module id = wxZn
// module chunks = 0